interface Props {
  label: string;
}

/**
 * Se muestra tanto en la conexión inicial como al cruzar una puerta. Cambiar de
 * sala es dejar una sala y entrar a otra, así que hay un hueco real que cubrir.
 */
export function Loading({ label }: Props) {
  return (
    <div className="overlay">
      <p className="panel loading">{label}</p>
    </div>
  );
}
